import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { dailyTokenRequest } from "./query";
import { DAILY_TOKEN_CACHE_KEY } from "./constants";

export const useDailyToken = () => {
  const queryClient = useQueryClient();

  const getCachedToken = useCallback(
    ({ meetingId }: { meetingId: string }) => {
      const token: string | undefined = queryClient.getQueryData([
        DAILY_TOKEN_CACHE_KEY,
        meetingId,
      ]);
      return token ?? null;
    },
    [queryClient],
  );

  const setCachedToken = useCallback(
    async ({ token, meetingId }: { token: string; meetingId: string }) => {
      queryClient.setQueryData([DAILY_TOKEN_CACHE_KEY, meetingId], token);
    },
    [queryClient],
  );

  const getToken = useCallback(
    async ({
      meetingId,
      isMicrophoneOn,
      isCameraOn,
      ignoreCache = false,
    }: {
      meetingId: string;
      isMicrophoneOn: boolean;
      isCameraOn: boolean;
      ignoreCache?: boolean;
    }) => {
      const cachedToken = getCachedToken({ meetingId });

      if (!cachedToken || ignoreCache) {
        const token = await dailyTokenRequest({
          meetingId,
          isMicrophoneOn,
          isCameraOn,
        });
        setCachedToken({ token, meetingId });
        return token;
      }

      return cachedToken;
    },
    [getCachedToken, setCachedToken],
  );

  return { getToken };
};
